import _ from 'lodash';
import { narrativeBoardActions } from '../actions/narrative-board.actions';
import { CONFIG } from '../helper/config';
import { NarrativeBoardOption, NarrativeBoardCard } from '../modal/narrative-board';

const initialState = {
    narrative_board_cards: [] as NarrativeBoardCard[],
    narrative_board_msg: '',
    show_loader:false,
    nb_card_current_page_count:1,
    nb_card_history_current_page_count:[] as number[],
    narrative_board_options: [] as NarrativeBoardOption[],
    is_get_more_cards:true,
    narrative_board_team_members:[]
};

/**
 * This is the reducer for the narrative board store.
 * It handles the state change based on the action dispatched.
 * The state is an object with the following properties:
 * - narrative_board_cards: An array of narrative board cards.
 * - narrative_board_msg: The current narrative board message.
 * - show_loader: A boolean indicating if the loader should be shown.
 * - nb_card_current_page_count: The current page count of narrative board cards.
 * - nb_card_history_current_page_count: An array of current page counts for card history.
 * - narrative_board_team_members: The team members of the narrative board.
 * - is_get_more_cards: A boolean indicating if more cards are being fetched.
 * - narrative_board_options: An array of options for the narrative board.
 */

export const narrativeBoardState = (state = initialState, action: any) => {
    let narrative_board_cards = state.narrative_board_cards.slice();
    let index : number = -1;
    switch (action.type) {
        case narrativeBoardActions.SET_NARRATIVE_BOARD_CARDS:{
            narrative_board_cards = narrative_board_cards.concat(action.payload.narrative_board_cards);
            let is_get_more_cards = action.payload.narrative_board_cards.length === CONFIG.NARRATIVE_BOARD_PAGINATION_LIMIT;
            let nb_card_current_page_count = state.nb_card_current_page_count + 1;
            return { ...state, ...{ narrative_board_cards: narrative_board_cards,  
                is_get_more_cards : is_get_more_cards, nb_card_current_page_count: nb_card_current_page_count,
                show_loader: false }};
            }
        case narrativeBoardActions.SET_NARRATIVE_BOARD_TEAM_MEMBERS:
            return  {...state,...{
                narrative_board_team_members:action.payload.narrative_board_team_members
            }}
        

        case narrativeBoardActions.EMPTY_NARRATIVE_BOARD_CARDS:
            return {...state, ...{ narrative_board_cards: [], nb_card_current_page_count:1 }};
        
        case narrativeBoardActions.UPDATE_NARRATIVE_BOARD_CARDS:
            index = narrative_board_cards.findIndex(nb=>nb.insight_id === action.payload.insight_card_id);
            if(index !== -1){
                narrative_board_cards.splice(index , 1);
            }
            return  {...state, ...{ narrative_board_cards: narrative_board_cards }};

        case narrativeBoardActions.SHOW_LOADER:
            if(state.is_get_more_cards && !action.payload.show_loader){
                return {...state , ...{show_loader:action.payload.show_loader, is_get_more_cards: false}};
            }else{
                return {...state , ...{show_loader:action.payload.show_loader}};
            }

        case narrativeBoardActions.SET_NARRATIVE_BOARD_MESSAGE:
            return {...state, ...{ narrative_board_msg: action.payload.narrative_board_msg }};

        case narrativeBoardActions.SET_NARRATIVE_BOARD_OPTIONS:
            return {...state, ...{ narrative_board_options: action.payload.narrative_board_options }};

        case narrativeBoardActions.SET_NARRATIVE_BOARD_CARD_HISTORY:{
            index = narrative_board_cards.findIndex(nb=>nb.insight_id === action.payload.insight_card_id);
            if(index !== -1){
                let history = narrative_board_cards[index].history;
                narrative_board_cards[index].history = _.isArray(history) ? history.concat(action.payload.narrative_board_card_history) : action.payload.narrative_board_card_history;
            }
            let nb_card_history_current_page_count = state.nb_card_history_current_page_count.slice();
            if(!nb_card_history_current_page_count[index]){
                nb_card_history_current_page_count.concat(2);
            }else{
                nb_card_history_current_page_count[index] = nb_card_history_current_page_count[index] + 1;
            }
            return {...state, ...{ narrative_board_cards: narrative_board_cards, nb_card_history_current_page_count: nb_card_history_current_page_count }};
        }
        case narrativeBoardActions.UPDATE_COMMENTS:{
        let nb_index = narrative_board_cards.findIndex(nb => nb.insight_id === action.payload.nb_insight_id);
        let history = narrative_board_cards[nb_index].history;
        if(_.isArray(history))
        index = history.findIndex(nb => nb.insight_id === action.payload.nb_card.insight_id && nb.sequence_id === action.payload.nb_card.sequence_id);
        if(index !== -1){
            narrative_board_cards[nb_index].history[index].comments = action.payload.comments;
        }
        return {...state, ...{narrative_board_cards : narrative_board_cards}};
        }
        default:
            return state;
    }
};
